export default __webpack_public_path__ + "static/media/sidebar.3915f447.png";